import { MutableRefObject, JSX, useState, useEffect } from 'react';
import { IconDirection } from '@bg-components/Icon';
import { partnerSettingsStore } from '@bg-shared';
import classNames from 'classnames';
import { useIsVisible } from './hooks/useIsVisible';
import { ArrowButton } from './ArrowButton';
import classes from './Controls.module.scss';

interface IProps {
    cardContainer: MutableRefObject<HTMLDivElement>;
    inLobby?: boolean;
}

export const Controls = (props: IProps): JSX.Element => {
    const [firstChild, setFirstChild] = useState<Element | null>(null);
    const [lastChild, setLastChild] = useState<Element | null>(null);
    const [scrollAmount, setScrollAmount] = useState<number>(0);

    useEffect(() => {
        const container = props.cardContainer.current;

        if (!container) {
            return;
        }

        if (container.children.length) {
            const firstCard = container.children[0];
            const styles = getComputedStyle(firstCard);
            setScrollAmount(parseInt(styles.marginRight, 10) + firstCard.clientWidth);
            setFirstChild(container.children[0]);
            setLastChild(container.children[container.children.length - 1]);
        }
    }, [firstChild, lastChild]);

    const isFirstCardVisible = useIsVisible(props.cardContainer.current, firstChild);
    const isLastCardVisible = useIsVisible(props.cardContainer.current, lastChild);

    if (isFirstCardVisible && isLastCardVisible) {
        return null;
    }

    const { isRtl } = partnerSettingsStore;

    const scrollModifiers = [1, -1];

    if (isRtl) {
        scrollModifiers.reverse();
    }

    const onArrowButtonClick = (direction: IconDirection) => {
        const modifier =
            direction === IconDirection.RIGHT ? scrollModifiers[0] : scrollModifiers[1];

        props.cardContainer.current?.scrollBy({
            top: 0,
            left: scrollAmount * modifier,
            behavior: 'smooth',
        });
    };

    return (
        <div className={classNames(classes.container, { [classes.lobby]: props.inLobby })}>
            <ArrowButton
                inLobby={props.inLobby}
                direction={IconDirection.LEFT}
                onClick={onArrowButtonClick}
                disabled={isFirstCardVisible}
            />
            <ArrowButton
                inLobby={props.inLobby}
                direction={IconDirection.RIGHT}
                onClick={onArrowButtonClick}
                disabled={isLastCardVisible}
            />
        </div>
    );
};
